import pages from "../secrets-web/src/pages";

// Auth pages
import Login from "./auth/login";
import Register from "./auth/register";
import Lock from "./auth/lock";
import Authenticate from "./auth/authenticate";
import Setup2FA from "./auth/setup-2fa";
import CreateMasterPassword from "./auth/create-master-password";

// Admin pages
import CreateWorkspace from "./admin/workspaces/create";
import Information from "./admin/settings/information";
import Members from "./admin/settings/members";

import ProjectMembers from "./admin/projects/members";

import AccountDetails from "./admin/account";
import Security from "./admin/security";

export default {
  ...pages,
  Login,
  Register,
  Lock,
  Authenticate,
  Setup2FA,
  CreateMasterPassword,

  CreateWorkspace,
  Information,
  Members,
  ProjectMembers,
  AccountDetails,
  Security
}